/*
 * @Author: qian.tang
 * @Date: 2023-09-21 10:30:26
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-10-19 15:22:29
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\apis\SummaryAPI.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { ASSET_MANAGEMENT_API as AM_API } from "utilities/AdiApi";
import { logError } from '../../RelationshipManagement/utilities/functions'
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";

type SUMMARY_TYPES = 'maintenance' | 'allocation_order' | 'alert' | 'asset'

const SummaryAPI = {

  getSummary: async (summaryTypes: SUMMARY_TYPES | SUMMARY_TYPES[]) => {
    try {
      const url = `${getBizCode()}/summary`
      const payload: any = {}
      if (Array.isArray(summaryTypes)) {
        summaryTypes.map(item => payload[item] = true)
      } else {
        payload[summaryTypes] = true
      }
      console.log('getSummary payload', payload)
      const res = await AM_API({
        url,
        method: 'POST',
        data: {
          ...payload
        }
      })

      console.log('getSummary res', res)
      if (Array.isArray(summaryTypes)) {
        return res.data
      } else {
        return res.data[summaryTypes]
      }



    } catch (e) {
      logError(e)
      console.log('getSummary fail...', e)
      throw e
    }
  },

}

export default SummaryAPI